import { CompositeLayer, MVTLayer } from "deck.gl";
import { generateUrlGeoserverVector, hideLoading, showLoading } from "../core/utils";
import { _TerrainExtension as TerrainExtension } from '@deck.gl/extensions'
import { linearScale } from "../singleLayer/renderLayerService";

export class StreetCommutersLayer extends CompositeLayer {
    name = "xxx";
    componentName = "xxx";
    workspace = "";
    layerName = "";
    is3D = false;
    domain = [2.0, 224.0, 99747.0]
    range = [[50, 205, 50], [255, 255, 0], [255, 50, 100]]
    opacity = 100

    constructor(workspace, layerName, is3D, opacity) {
        super();

        this.workspace = workspace;
        this.layerName = layerName;
        this.is3D = is3D;
        this.opacity = opacity
    }

    shouldUpdateState({ changeFlags }) {
        return changeFlags.somethingChanged;
    }


    renderLayers() {
        const { zoom } = this.context.viewport;
        const dataSource = generateUrlGeoserverVector(this.workspace, this.layerName)

        return [
            new MVTLayer({
                id: 'sumatraStreetCommuters1',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                pickable: true,
                getLineColor: f => linearScale(f.properties.n_commuters_on_road, this.domain, this.range),
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 1000

                        default:
                            return 0
                    }
                },

                visible: zoom < 7.5
            }),
            new MVTLayer({
                id: 'sumatraStreetCommuters2',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                pickable: true,
                getLineColor: f => linearScale(f.properties.n_commuters_on_road, this.domain, this.range),
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 700

                        case 22:
                        case 24:
                        case 14:
                        case 17:
                            return 300

                        default:
                            return 0
                    }
                },

                visible: zoom >= 7.5 && zoom < 9.5
            }),
            new MVTLayer({
                id: 'sumatraStreetCommuters3',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                pickable: true,
                getLineColor: f => linearScale(f.properties.n_commuters_on_road, this.domain, this.range),
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 200

                        case 22:
                        case 24:
                        case 14:
                        case 17:
                            return 120


                        case 18:
                        case 16:
                            return 75

                        default:
                            return 0
                    }
                },

                visible: zoom >= 9.5 && zoom < 12
            }),
            new MVTLayer({
                id: 'sumatraStreetCommuters4',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                pickable: true,
                getLineColor: f => linearScale(f.properties.n_commuters_on_road, this.domain, this.range),
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 30

                        case 22:
                        case 24:
                        case 14:
                        case 16:
                        case 17:
                        case 18:
                            return 20

                        case 5:
                        case 20:
                        case 23:
                            return 15

                        default:
                            return 3
                    }
                },

                visible: zoom >= 12
            }),
            new MVTLayer({
                id: 'sumatraStreetCommuters5',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                pickable: true,
                getLineColor: f => linearScale(f.properties.n_commuters_on_road, this.domain, this.range),
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 1000

                        default:
                            return 0
                    }
                },
                terrainDrawMode: this.is3D ? 'drape' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],

                visible: zoom < 7.5
            }),
            new MVTLayer({
                id: 'sumatraStreetCommuters6',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                pickable: true,
                getLineColor: f => linearScale(f.properties.n_commuters_on_road, this.domain, this.range),
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 700

                        case 22:
                        case 24:
                        case 14:
                        case 17:
                            return 300

                        default:
                            return 0
                    }
                },

                terrainDrawMode: this.is3D ? 'drape' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],

                visible: zoom >= 7.5 && zoom < 9.5
            }),
            new MVTLayer({
                id: 'sumatraStreetCommuters7',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                pickable: true,
                getLineColor: f => linearScale(f.properties.n_commuters_on_road, this.domain, this.range),
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 200

                        case 22:
                        case 24:
                        case 14:
                        case 17:
                            return 120


                        case 18:
                        case 16:
                            return 75

                        default:
                            return 0
                    }
                },

                terrainDrawMode: this.is3D ? 'drape' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],

                visible: zoom >= 9.5 && zoom < 12
            }),
            new MVTLayer({
                id: 'sumatraStreetCommuters8',
                data: dataSource,
                onTileLoad: showLoading,
                onViewportLoad: hideLoading,
                opacity: this.opacity / 100,
                stroked: true,
                pickable: true,
                getLineColor: f => linearScale(f.properties.n_commuters_on_road, this.domain, this.range),
                getLineWidth: f => {
                    switch (f.properties.fclass) {
                        case 1:
                        case 26:
                        case 10:
                        case 15:
                            return 30

                        case 22:
                        case 24:
                        case 14:
                        case 16:
                        case 17:
                        case 18:
                            return 20

                        case 5:
                        case 20:
                        case 23:
                            return 15

                        default:
                            return 3
                    }
                },

                terrainDrawMode: this.is3D ? 'drape' : '',
                extensions: this.is3D ? [new TerrainExtension()] : [],

                visible: zoom >= 12
            }),
        ]
    }
}